import api from "./api";
import API_URLS from "../../constants/api-urls";

export default class CaskAndAgingApi {
  createCanVariety(payload) {
    return api.post(API_URLS.URL.canevariety.createCaneVariety, payload);
  }

  updateCanVariety(canVarietyID, payload) {
    return api.put(
      API_URLS.URL.canevariety.updateCaneVariety?.replace(
        ":id",
        canVarietyID,
      ),
      payload,
    );
  }

  getCanVarietyList(payload) {
    return api.post(API_URLS.URL.canevariety.getCaneCarietyList, payload);
  }

  deleteCanVariety(canVarietyID) {
    return api.delete(
      API_URLS.URL.canevariety.updateCaneVariety?.replace(
        ":id",
        canVarietyID,
      )
    );
  }

}
